import React from "react";

import MainPage from "layouts/Main/MainPage/MainPage";
import LandingPage from "layouts/Landing/LandingPage";
import { Route } from "interfaces/infra";

const routes: Route[] = [
  {
    type: "collapse",
    noCollapse: true,
    name: "landing",
    key: "landing",
    route: "/landing",
    component: <LandingPage />,
    minWindowSize: 1200,
  },
  {
    type: "collapse",
    noCollapse: true,
    name: "mainpage",
    key: "mainpage",
    route: "/mainpage",
    // icon: <HomepageIcon />,
    component: <MainPage />,
    // role: [UserRole.USER, UserRole.ADMIN],
    minWindowSize: 1200,
  },
 ];

export default routes;
